.textareaInput {
  /* Default WebKit scrollbar */
  &::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }

  &::-webkit-scrollbar-track {
    box-shadow: none;
    border-radius: 10px;
  }

  /* Show thumb on hover */
  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: #555;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 255, 255, 1); //#555;
  }

  &::-webkit-scrollbar-thumb:window-inactive {
    display: none;
  }

  /* 🔹 When hidden class is present */
  &.hidden {
    &::-webkit-scrollbar {
      display: none; // hides the scrollbar completely
    }
  }
}
